import type { ScheduleHealth } from "@shared/types";

export function fmtDate(d: string | null | undefined): string {
  if (!d) return "—";
  const t = Date.parse(d.length <= 10 ? `${d}T00:00:00Z` : d);
  if (Number.isNaN(t)) return "—";
  return new Date(t).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(d: string | null | undefined): string {
  if (!d) return "—";
  const t = Date.parse(d);
  if (Number.isNaN(t)) return "—";
  return new Date(t).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fromNow(d: string | null | undefined): string {
  if (!d) return "";
  const diff = Date.now() - Date.parse(d);
  const min = Math.round(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.round(h / 24);
  if (days < 30) return `${days}d ago`;
  return fmtDate(d);
}

export function money(n: number | null | undefined, currency = "OMR"): string {
  const v = Number(n || 0);
  return `${currency} ${v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 3 })}`;
}

export function pct(n: number | null | undefined): string {
  return `${Math.round(Number(n || 0))}%`;
}

export const HEALTH_META: Record<ScheduleHealth, { label: string; color: string; bg: string }> = {
  on_track: { label: "On Track", color: "rgb(var(--st-ontrack))", bg: "rgb(var(--st-ontrack) / 0.12)" },
  ahead: { label: "Ahead", color: "rgb(var(--st-ahead))", bg: "rgb(var(--st-ahead) / 0.12)" },
  delayed: { label: "Delayed", color: "rgb(var(--st-delayed))", bg: "rgb(var(--st-delayed) / 0.12)" },
  cancelled: { label: "Cancelled", color: "rgb(var(--st-cancelled))", bg: "rgb(var(--st-cancelled) / 0.14)" },
  planned: { label: "Planned", color: "rgb(var(--st-planned))", bg: "rgb(var(--st-planned) / 0.16)" },
  done: { label: "Completed", color: "rgb(var(--st-ontrack))", bg: "rgb(var(--st-ontrack) / 0.16)" },
};

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");
}

export function priorityRank(p: string): number {
  return { Critical: 0, High: 1, Medium: 2, Low: 3 }[p] ?? 2;
}
